import React from 'react';
import { BulbOutlined, EditOutlined, FolderOpenOutlined, SearchOutlined } from '@ant-design/icons';

import type { PromptCard, XoePromptCardProps } from '../../types/xoe/XoeUiTypes';

const iconFor = (kind: PromptCard['kind']) => {
	switch (kind) {
		case 'write':
			return <EditOutlined />;
		case 'open':
			return <FolderOpenOutlined />;
		case 'external':
			return <SearchOutlined />;
		default:
			return <BulbOutlined />;
	}
};

const XoePromptCard: React.FC<XoePromptCardProps> = ({ card, onSelect }) => (
	<button
		type="button"
		className="mg-xoe-prompt"
		data-testid="xoe-home-prompt"
		data-kind={card.kind}
		data-action-type={card.actionType}
		onClick={() => onSelect(card.template)}
	>
		<span className="mg-xoe-prompt-icon">{iconFor(card.kind)}</span>
		<span className="mg-xoe-prompt-text">
			<span className="mg-xoe-prompt-label">{card.label}</span>
			{card.description && <span className="mg-xoe-prompt-desc">{card.description}</span>}
		</span>
	</button>
);

export default XoePromptCard;
